import { render, staticRenderFns } from "./PedidosNavigationMobile.vue?vue&type=template&id=541f32c2&scoped=true&"
import script from "./PedidosNavigationMobile.vue?vue&type=script&lang=ts&"
export * from "./PedidosNavigationMobile.vue?vue&type=script&lang=ts&"
import style0 from "./PedidosNavigationMobile.vue?vue&type=style&index=0&id=541f32c2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f32c2",
  null
  
)

export default component.exports